import React, {createContext, useState} from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { ThemeProvider } from '@mui/material/styles';
import { CssBaseline } from '@mui/material';
import theme from './theme';

// Import des pages
import Dashboard from './pages/Dashboard';
import SetPassword from './pages/SetPassword';
import ForgotPassword from './pages/ForgotPassword';
import Login from './pages/Login';
import ModelManager from './pages/ModelManager';
import CreateModel from './pages/CreateModel';
import CreateDesignFromModel from './pages/CreateDesignFromModel';
import ViewModel from './pages/ViewModel';
import DesignManager from './pages/DesignManager';
import EditDesign from './pages/EditDesign';
import ViewDesign from './pages/ViewDesign';
import UsersManager from './pages/UsersManager';

// Import des polices 

export const Context = createContext()

function App() {
  const [userId, setUserId] = useState(sessionStorage.getItem('user') || null);
  const [isConnected, setConnected] = useState(!!sessionStorage.getItem('token'));

  const deconnect = () => {
    sessionStorage.clear();
    setUserId(null);
    setConnected(false);
    window.location.href = "/login";
  }

  return (
    <Context.Provider value={{userId, setUserId, isConnected, setConnected, deconnect}}>
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <Router>
        <Routes>
          <Route path='/set-password/:token' element={<SetPassword />} />
          <Route path='/forgot-password' element={<ForgotPassword />} />
          {isConnected ? <>
            <Route path="/" element={<Dashboard />} />
            <Route path='/set-password/:token' element={<SetPassword />} />
            <Route path="/model" element={<ModelManager />} />
            <Route path="/model/new" element={<CreateModel />} />
            <Route path="/model/:id/edit" element={<CreateModel />} />
            <Route path="/model/:id/view" element={<ViewModel />} />
            <Route path="/design" element={<DesignManager />} />
            <Route path="/design/new" element={<CreateDesignFromModel />} />
            <Route path="/design/:id/edit" element={<EditDesign />} />
            <Route path="/design/:id/view" element={<ViewDesign />} />
            <Route path='/users' element={<UsersManager />} />
            <Route path="*" element={<Dashboard />} />
          </> : <>
            <Route path="/login" element={<Login />} />
            <Route path='/set-password/:token' element={<SetPassword />} />
            <Route path="*" element={<Login />} />
          </>}
        </Routes>
      </Router>
    </ThemeProvider>
    </Context.Provider>
  );
}
export default App;